// Layout.js
import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import { Outlet } from 'react-router-dom';
import LogoutShortcutListener from './components/LogoutShortcutListener';

const Layout = () => {
  return (
    <>
     <LogoutShortcutListener />
     
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        direction: 'rtl',
      }}
    >
      <CssBaseline />

      {/* رأس الصفحة */}
      <Header />

      {/* المحتوى الرئيسي */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          background: '#F4F5E7',
          padding: 3,
          marginTop: '64px', // ارتفاع الـ AppBar
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 1200 }}>
          <Outlet />
        </Box>
      </Box>

      {/* تذييل الصفحة */}
      <Footer />
    </Box>
    </>
  );
};

export default Layout;

